import PropTypes from 'prop-types';
import List from '@mui/material/List';

const MarkdownUnorderListRenderer = ({ children }) => (
	<List
		sx={{
			listStyleType: 'disc',
			listStylePosition: 'inside',
			my: 0,
			py: 0,
		}}
	>
		{children}
	</List>
);

MarkdownUnorderListRenderer.propTypes = {
	children: PropTypes.node.isRequired,
};

export default MarkdownUnorderListRenderer;
